import { fetchFromObject } from 'helpers/object';

export default {
  getBBVADataField: state => field => fetchFromObject(state, field)
};
